import { SxProps } from "@mui/material";

export interface IProductCategory {
  name: string;
  categor_id: string;
  price: number;
  _id: string;
  listProductSKU: ProductSku[];
  ref_master_id: string;
  codes: string[];
  ref_attachments: any[];
  ref_attributes: RefAttribute[];
  is_displayed: boolean;
  category_name: string;
  count: any;
  is_active: boolean;
  allow_sale: boolean;
  is_price_contact?: boolean
}

export type ProductSku = {
  _id: string;
  allow_sale: boolean;
  branch_id: string;
  branch_name: string;
  category_id: string;
  category_name: string;
  code: string;
  created_at: number;
  description: string;
  is_active: boolean;
  is_master: boolean;
  is_sku_active: boolean;
  is_sku_in_stock: boolean;
  is_topping: boolean;
  long_name: string;
  merchant_id: string;
  merchant_name: string;
  name: string;
  on_hand: number;
  platform: string;
  price: number;
  promotion: number;
  ref_attachments: any[];
  ref_attributes: RefAttribute[];
  ref_id: string;
  ref_master_id: string;
  ref_topping: any[];
  remain: number;
  type: number;
  updated_at: number;
  is_displayed: boolean;
  has_sku_displayed: boolean;
  is_emenu: boolean;
  is_web_order: boolean;
  price_web_order: number;
  id: string;
};

export interface RefAttribute {
  id: string;
  name: string;
  value: string;
  type: string;
  options: string[];
  options_in_stock: string[];
}

export interface ICategoryDetail {
  name: string;
  id: string;
  total: number;
  products: IProductCategory[];
  outstanding_type?: string
}

export interface IFeaturedCategories {
  name: string;
  id: string;
  product_number: number;
  status: boolean;
  enable: boolean;
  outstanding_type?: 'top_newest' | 'top_seller';
  _id: string;
}

export interface ITableRowExpandedProps {
  data: any;
  columns: TableHeadData[];
  children?: React.ReactNode;
  isActive?: boolean;
  sx?: SxProps;
}

export type TableHeadData = {
  id: string;
  label: string;
  width?: number | string;
  align?: string;
  key: string;
  childrenSlot?: React.ReactNode;
  childrenType?: "text" | "checkbox" | "switch";
  isSort?: boolean;
  sx?: SxProps;
};

export const PRODUCT_TYPE_COMBO = 1;
export const PRODUCT_TYPE_OTHER = 2;
export const PRODUCT_TYPE_SERVICE = 3;
